import React, { useEffect } from 'react';

/**
 * The shell every Picture AI panel opens in: overlay, Escape, click outside, scrollable body.
 *
 * The heavier controls — writing a prompt, replaying history, trying a picture — get room here
 * instead of stretching the configuration screen, which is meant to be read at a glance.
 */
const Modal = ({ open, onClose, title, subtitle, width = 'max-w-5xl', footer, children }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/70 p-4" onClick={onClose}>
      <div
        className={`mt-8 flex max-h-[90vh] w-full ${width} flex-col rounded-2xl bg-white shadow-2xl dark:bg-gray-900`}
        onClick={event => event.stopPropagation()}
      >
        <header className="flex items-start justify-between gap-4 border-b border-gray-200 p-6 dark:border-gray-700">
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{title}</h2>
            {subtitle && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
          </div>
          <button
            className="rounded-lg px-3 py-1 text-xl leading-none text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800"
            aria-label="Close"
            onClick={onClose}
          >
            ×
          </button>
        </header>

        <div className="flex-1 overflow-y-auto p-6">{children}</div>

        {footer && (
          <footer className="flex flex-wrap items-center justify-end gap-3 border-t border-gray-200 p-4 dark:border-gray-700">
            {footer}
          </footer>
        )}
      </div>
    </div>
  );
};

export default Modal;
